import React from 'react';
import { useTranslation } from 'react-i18next';
import { IcoButtonSimple } from '@/components/UI/IcoButton/IcoButton';
import useToastContext from '@/hooks/useToastContext';
import ErrorImg from '@/assets/images/critical-error-logo.png';
import styles from './ErrorPage.module.scss';

type ErrorPageProps = {
  code: string;
  status?: number;
  message: string;
};

const ErrorPage: React.FC<ErrorPageProps> = (props) => {
  const { code, status, message } = props;
  const { t } = useTranslation();
  const { addToast } = useToastContext();

  const copyErrorStatus = () => {
    navigator.clipboard.writeText(code).then(() => {
      addToast(t('errors.copyErrorOK'));
    }).catch(() => addToast(t('errors.copyErrorKO'), 'ERROR'));
  };

  return (
    <div className={styles.Content}>
      <img src={ErrorImg} alt="Critical error" />
      <section>
        <h1>{t('errors.oops')}</h1>
        <p>{t('errors.criticalErrorText1')}</p>
        <p>{t('errors.criticalErrorText2')}</p>
        <p className={styles.Message}>{code} ({status}) - {message}</p>

        <IcoButtonSimple
          id="btn-copy-error"
          icon="icon-datei-doppelt-kopieren"
          tooltipText={t('errors.copyErrorCode')}
          handleClick={copyErrorStatus}
        />
      </section>
    </div>
  );
};

export default ErrorPage;
